import PhoneInput from "react-phone-input-2";
import { PhoneInputContainer } from "./styled";
import { FormHelperText } from "@mui/material";
import React from "react";

const BarekamPhoneInput = ({
  value,
  placeholder,
  width,
  error,
  errorMessage,
  onChange,
  onKeyUp,
  isReadonly,
  formatted,
}: BarekamPhoneInputProps) => {
  return (
    <PhoneInputContainer style={{ width: width || "100%" }}>
      <PhoneInput
        country={"am"}
        specialLabel={placeholder + " *"}
        value={value}
        onChange={(value, data, event, formattedValue) =>
          onChange(formatted ? formattedValue : value)
        }
        onEnterKeyPress={(event) => onKeyUp && onKeyUp(event as any)}
        disabled={isReadonly}
        autoFormat
        isValid={!error}
      />

      {!!error && (
        <FormHelperText error id="input-error">
          {errorMessage}
        </FormHelperText>
      )}
    </PhoneInputContainer>
  );
};

interface BarekamPhoneInputProps {
  value: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  onChange: Function;
  onKeyUp?: (event: KeyboardEvent) => void;
  placeholder: string;
  width?: string;
  isReadonly?: boolean;
  error?: boolean;
  errorMessage?: string;
  formatted?: boolean;
}

export default BarekamPhoneInput;
